import { AnimatePresence } from 'motion/react';
/**
 * Wrap your token components with this to enable animations
 * when they are added or removed from the DOM.
 */
export const TokenPresence = AnimatePresence;
//# sourceMappingURL=TokenPresence.js.map